import React from 'react';
import {useNavigate} from 'react-router-dom';

interface AdminSidebarLinkProps {
  icon: string;
  text: string;
  isActive?: boolean;
  onClick?: () => void;
  link?: string;
}

const AdminSidebarLink: React.FC<AdminSidebarLinkProps> = ({ 
  icon, 
  text, 
  isActive = false, 
  onClick,
  link
}) => {
  const baseClasses = "flex items-center text-gray-600 hover:text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-sm text-sm cursor-pointer";
  const activeClasses = isActive ? "bg-gray-100 text-gray-900" : "";
  const combinedClasses = `${baseClasses} ${activeClasses}`.trim();
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (link) {
      navigate(link);
    } else {
      console.log('No action defined for sidebar link');
    }
  };

  return (
    <li>
      <span className={combinedClasses} onClick={handleClick}>
        <i className={`fa ${icon} mr-3 w-4`}></i>
        {text}
      </span>
    </li>
  );
};

export default AdminSidebarLink;
